/**

The MIT License (MIT)

Copyright (c) 2016 Andreas Wolf

Permission is hereby granted, free of charge, to any person obtaining a copy of
this software and associated documentation files (the "Software"), to deal in
the Software without restriction, including without limitation the rights to
use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies
of the Software, and to permit persons to whom the Software is furnished to do
so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.

 */

import React from 'react';
import p5 from 'p5';

export default class P5Wrapper extends React.Component {
  componentDidMount() {
    this.makeSketch(this.props.sketch);

    if (this.canvas.myCustomRedrawAccordingToNewPropsHandler) {
      this.canvas.myCustomRedrawAccordingToNewPropsHandler(this.props);
    }
  }

  componentWillReceiveProps(newprops) {
    if (this.props.sketch !== newprops.sketch) {
      try {
        this.canvas.remove();
      } catch (err) {
        console.error(err);
      }
      this.makeSketch(newprops.sketch);
    }

    if (this.canvas.myCustomRedrawAccordingToNewPropsHandler) {
      this.canvas.myCustomRedrawAccordingToNewPropsHandler(newprops);
    }
  }

  makeSketch(sketch) {
    this.canvas = new p5(sketch, this.wrapper);
    this.canvas.onChange = this.props.onChange || (() => {});
  }

  render() {
    return (
      <div
        className={this.props.className}
        style={this.props.style}
        ref={wrapper => (this.wrapper = wrapper)}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/P5Wrapper.js